import { Api } from '@/infrastructure';
import { Partner } from '@/types';
import { useCallback } from 'react';

type PartnerRequestBody = {
  [key: string]: Record<string, unknown>;
};

type UsePartnerEditHook = {
  fetchPartner: (id: string) => Promise<Partner>;
  updatePartner: (
    id: string,
    requestBody: PartnerRequestBody
  ) => Promise<Partner>;
};

export const usePartnerEdit = (): UsePartnerEditHook => {
  const fetchPartner = useCallback(async (id: string): Promise<Partner> => {
    const response = await Api.get<Partner>(`partners/${id}`, 'partner');
    return response.data;
  }, []);

  const updatePartner = async (
    id: string,
    requestBody: PartnerRequestBody
  ): Promise<Partner> => {
    const response = await Api.patch<Partner>(
      `partners/${id}`,
      'partner',
      requestBody
    );
    return response.data;
  };

  return {
    fetchPartner,
    updatePartner,
  };
};
